import React, { useState } from "react";
import * as Feather from "react-feather";
import { Link } from "react-router-dom";

const TopNavBar = () => {
  // const authUser = JSON.parse(localStorage.getItem("VVRHCS"));
  // console.log(authUser);
   const [logged, setLogged] = useState(() => {
      return localStorage.getItem("isLoggedIn") === "true";
    });

    const handleLogout = () => {
    setLogged(false);
    localStorage.removeItem("isLoggedIn");
  };
  
  return (
    <nav className="top-navbar navbar navbar-expand navbar-light fixed-top">
      <i className="fas fa-user" style={{ color: "black" }}></i>

      <span
        style={{
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "20px",
          color: "black",
          marginLeft: "10px",
          textTransform: "capitalize",
        }}
      >
        {/* {authUser.username} */}
        Admin portal
      </span>

      <ul className="navbar-nav ml-auto ">
        <li className="nav-item">
          <Link to="/admin/login" className="nav-link" role="button">
            <button type="button" className="btn" onClick={handleLogout}>
                      <Feather.LogOut/>
            </button>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link"
            data-widget="pushmenu"
            to="#"
            role="button"
          >
            <i className="fas fa-bars" style={{ color: "black" }}></i>
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i
              className="fas fa-expand-arrows-alt"
              style={{ color: "black" }}
            ></i>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default TopNavBar;
